import { FC } from 'react';
import classNames from 'classnames';
import Button from 'src/Components/Button';
import { IFilterProps } from '.';
import { ReactComponent as SearchIcon } from '../../assets/search.svg';
import st from './DefFilterCommon.module.scss';

/** Компонента для дефолтного рендера текстового фильтра таблицы */
const Text: FC<IFilterProps> = (props) => {
	const {
		columnId,
		isShowModal,
		value,
		setValue,
		cancelHandler,
		applyValueHandler,
	} = props;

	/** Возвращает текст-подсказку в зависимости от состояния тек. значения */
	const getHelperText = () => {
		if (!value.length) {
			return 'Введите минимум 3 символа';
		} else if (value.length === 1) {
			return 'Введите еще 2 символа';
		} else if (value.length === 2) {
			return 'Введите еще 1 символ';
		}
		return '';
	};

	/** Рендер кнопок отмена/применить */
	const renderButtons = () => {
		return (
			<div className={st.modalButtons}>
				<Button
					id={'filter_cancel-' + columnId}
					onClick={cancelHandler}
					variant="red"
					outline
				>
					Отмена
				</Button>
				<Button
					id={'filter_apply-' + columnId}
					onClick={applyValueHandler}
				>
					Применить
				</Button>
			</div>
		);
	};

	/** Рендер текста подсказки */
	const renderTextHelp = (helperText: string) => {
		return <span className="body-small">{helperText}</span>;
	};

	/** Рендер тела модалки */
	const renderModalBody = () => {
		const helperText = getHelperText();
		if (helperText) {
			return renderTextHelp(helperText);
		} else {
			return renderButtons();
		}
	};

	return (
		<>
			<SearchIcon />
			<input
				className="body-small"
				readOnly={!isShowModal}
				value={value}
				onChange={(e) => {
					return setValue(e.target.value);
				}}
			/>
			{isShowModal && (
				<div className={classNames(st.modalBody, st.styles)}>
					{renderModalBody()}
				</div>
			)}
		</>
	);
};

export default Text;
